/**
 * Utility functions for the frontend
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes with proper conflict resolution.
 * Combines clsx for conditional classes with tailwind-merge for Tailwind-specific merging.
 *
 * @example
 * cn('px-2 py-1', 'px-4') // Returns 'py-1 px-4' (px-4 overrides px-2)
 * cn('bg-red-500', condition && 'bg-blue-500') // Conditional class
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
